import type { AuthProvider } from '@/core/infrastructure/services/ApiService'
import auth0Client from '@/presentation/plugins/auth0'

/**
 * Adapter Auth0 qui implémente l'interface AuthProvider
 * Découple ApiService de la dépendance directe à Auth0
 */
export class Auth0Provider implements AuthProvider {
  isAuthenticated(): boolean {
    return auth0Client.isAuthenticated.value
  }

  async getAccessToken(): Promise<string | null> {
    try {
      if (this.isAuthenticated()) {
        return await auth0Client.getAccessTokenSilently()
      }
      return null
    } catch (error) {
      console.error('Erreur lors de la récupération du token:', error)
      return null
    }
  }

  async refreshToken(): Promise<string | null> {
    try {
      // Forcer le refresh du token
      const token = await auth0Client.getAccessTokenSilently({
        cacheMode: 'off' // Force un nouveau token
      })
      return token
    } catch (error) {
      console.error('Erreur lors du refresh du token:', error)
      return null
    }
  }

  async redirectToLogin(): Promise<void> {
    try {
      // Sauvegarder l'URL actuelle pour redirection après login
      const currentRoute = window.location.pathname + window.location.search
      if (currentRoute !== '/' && currentRoute !== '/callback') {
        localStorage.setItem('auth_redirect_to', currentRoute)
      }

      await auth0Client.loginWithRedirect()
    } catch (error) {
      console.error('Erreur lors de la redirection vers login:', error)
      // Fallback: rediriger manuellement
      window.location.href = '/login'
    }
  }
}
